import { useGetSignedAgreements } from "@src/appV2/Agreements/api/useGetSignedAgreements";
import { AgreementKind } from "@src/appV2/Agreements/types";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

interface UseHasSignedJobSearchAgreementResult {
  hasSigned: boolean;
  isLoading: boolean;
}

export function useHasSignedJobSearchAgreement(): UseHasSignedJobSearchAgreementResult {
  const worker = useDefinedWorker();

  const { data, isLoading, isSuccess } = useGetSignedAgreements({
    workerId: worker.userId,
    kind: [AgreementKind.JOB_SEARCH],
  });

  const hasSigned = isSuccess && (data?.data?.length ?? 0) > 0;

  return { hasSigned, isLoading };
}
